import { matchPath } from 'react-router-dom';

import { isKnownAccountPath } from './isKnownRoute';

/**
 * Resolve which app shell (header/footer) a given pathname should render.
 *
 * Shell config is declared per route via an optional `shell: { header, footer }`.
 * Defaults keep existing behavior:
 *   - header: shown on private routes, hidden on public ones
 *   - footer: hidden unless a route opts in
 *
 * `routes` is injected (rather than imported) so this stays a pure, easily
 * testable function decoupled from the app's route/container graph.
 *
 * The active route is resolved the same way <Switch> resolves it: first match
 * wins, honoring each route's `exact` flag.
 */
export const findActiveRoute = (pathname, routes) =>
  routes.find((route) =>
    matchPath(pathname, { path: route.path, exact: route.exact })
  );

export const resolveShell = (pathname, routes) => {
  const route = findActiveRoute(pathname, routes);

  if (
    route?.path === '/' &&
    route.exact === false &&
    !isKnownAccountPath(pathname)
  ) {
    return { header: false, footer: false };
  }

  const shell = route?.shell ?? {};

  return {
    header: shell.header ?? Boolean(route?.private),
    footer: shell.footer ?? false,
  };
};
